export default {

  data() {
    return {
      localizedFrequencies: [
        {
          key: 'Daily',
          value: 'message.frequencyOnceDaily'
        },
        {
          key: 'Twice daily',
          value: 'message.frequencyTwiceDaily'
        },
        {
          key: 'Three times daily',
          value: 'message.frequencyThreeDaily'
        },
        {
          key: 'Weekly',
          value: 'message.frequencyWeekly'
        },
        {
          key: 'Every 6 weeks',
          value: 'message.frequencyEverySixWeeks'
        },
        {
          key: 'Four times daily',
          value: 'message.frequencyFourTimesDaily'
        },
        {
          key: 'Every 3 months',
          value: 'message.frequencyEveryThreeMonths'
        },
        {
          key: 'Five times daily',
          value: 'message.frequencyFiveTimesDaily'
        },
        {
          key: 'Every Other Week',
          value: 'message.frequencyEveryOtherWeek'
        },
        {
          key: 'Every 3 Weeks',
          value: 'message.frequencyEveryThreeWeeks'
        },
        {
          key: 'Monthly',
          value: 'message.frequencyMonthly'
        },
        {
          key: 'Every 8 Weeks',
          value: 'message.frequencyEveryEightWeeks'
        },
        {
          key: 'Every 12 Weeks',
          value: 'message.frequencyEveryTwelveWeeks'
        },
        {
          key: 'Every 6 months',
          value: 'message.frequencyEverySixMonths'
        },
        {
          key: 'Every 8 months',
          value: 'message.frequencyEveryEightMonths'
        },
        {
          key: 'Yearly',
          value: 'message.frequencyYearly'
        },
        {
          key: 'One time',
          value: 'message.frequencyOneTime'
        },
        {
          key: 'As needed',
          value: 'message.frequencyAsNeeded'
        }
      ]
    }
  },
  methods: {
    localizeFrequency(key) {

      let self = this;
      return self.localizedFrequencies.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/MedicationFrequencies/index.js